<template>
  <div id="app">

    <navbar />
    <div id="wrapper">
      <div id="page-content-wrapper">
        <sidebar />
        <router-view></router-view>
        <my-footer />
      </div>


    </div>

  </div>
</template>

<script>
  import Navbar from '@/components/Navbar'
  import Sidebar from '@/components/Sidebar'
  import MyFooter from '@/components/Footer'
  export default {
    name: 'app',
    components: {
      Navbar,
      MyFooter,
      Sidebar
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// App.vue?04e9d6eb